export default __webpack_public_path__ + "static/media/Footfall_Insight.270d4796.jpg";